<script setup>
import StatCard from "@/components/global-themed/StatCard.vue";
import HintSquare from "@/components/global-themed/HintSquare.vue";
import {useStore} from "vuex";
import {computed} from "vue";

const store = useStore();

const actualMetric = computed(() => store.getters['competitionV2/keywordActualMetric']);

const top3Positions = computed(() => {
  if (!actualMetric.value) {
    return undefined;
  }

  return actualMetric.value.pos1 + actualMetric.value.pos2_3;
});

const page1 = computed(() => {
  if (!actualMetric.value) {
    return undefined;
  }

  return actualMetric.value.pos1 + actualMetric.value.pos2_3 + actualMetric.value.pos4_10;
});

const page2 = computed(() => {
  if (!actualMetric.value) {
    return undefined;
  }

  return actualMetric.value.pos11_20;
});

const totalKeywords = computed(() => {
  if (!actualMetric.value) {
    return undefined;
  }

  return actualMetric.value.organic_count;
});

</script>

<template>
  <div class="tw-grid-cols-4 tw-grid tw-gap-4">
    <StatCard>
      <template #stat>
        {{ top3Positions ?? 'N/A' }}
      </template>
      <template #title>
        <span>Top 3 Positions</span>
        <HintSquare
          hint="The total number of keywords we monitor, showing where the selected website ranks within the first 3 positions of Google search results."
        />
      </template>
    </StatCard>

    <StatCard>
      <template #stat>
        {{ page1 ?? 'N/A' }}
      </template>
      <template #title>
        <span>Page 1</span>
        <HintSquare
          hint="The total number of keywords we monitor, showing where the selected website ranks on the first page of Google search results. This also includes the count of keywords in position 1-3."
        />
      </template>
    </StatCard>

    <StatCard>
      <template #stat>
        {{ page2 ?? 'N/A' }}
      </template>
      <template #title>
        <span>Page 2</span>
        <HintSquare
          hint="The total number of keywords we monitor, showing where the selected website ranks on the second page of Google search results."
        />
      </template>
    </StatCard>

    <StatCard>
      <template #stat>
        {{ totalKeywords ?? 'N/A' }}
      </template>
      <template #title>
        <span>Total Keywords</span>
        <HintSquare
          title="The total number of keywords we monitor, showing where the selected website ranks within the first 10 pages of Google search results."
        />
      </template>
    </StatCard>
  </div>
</template>
